import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export type Meta = {
  title: string;
  authRequired: boolean;
  beforeResolve?: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => void;
};
export default [
  {
    path: '/',
    redirect: { name: 'mypage' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login/index.vue'),
    meta: {
      title: 'ログイン',
      authRequired: false,
    },
  },
  {
    path: '/tmp-register',
    name: 'temporaryRegister',
    component: () => import('../pages/register-user/index.vue'),
    meta: {
      title: 'ユーザ登録',
      authRequired: false,
    },
  },
  {
    path: '/cpl-register',
    name: 'completionOfRegistration',
    component: () => import('../pages/register-user/complete.vue'),
    meta: {
      title: '本登録完了',
      authRequired: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../pages/password/forgot.vue'),
    meta: {
      title: 'パスワード再発行',
      authRequired: false,
    },
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: () => import('../pages/password/index.vue'),
    meta: {
      title: 'パスワード再設定',
      authRequired: false,
    },
  },
  {
    path: '/mypage',
    name: 'mypage',
    meta: {
      title: 'マイページ',
      authRequired: true,
    },
    component: () => import('../pages/mypage/index.vue'),
  },
  {
    path: '/application',
    name: 'application',
    meta: {
      title: '申込・支払',
      authRequired: true,
    },
    component: () => import('../pages/application/index.vue'),
  },
  {
    path: '/payment/complete',
    name: 'paymentComplete',
    meta: {
      title: '支払い完了',
      authRequired: true,
    },
    component: () => import('../pages/payment/complete.vue'),
  },
  {
    path: '/select-course',
    name: 'selectCourse',
    meta: {
      title: 'コース選択',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/index.vue'),
  },
  {
    path: '/select-contents/:courseId',
    name: 'selectContents',
    meta: {
      title: 'コンテンツ選択',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/contents/index.vue'),
  },
  {
    path: '/test/:contentId',
    name: 'test',
    meta: {
      title: 'ミニテスト',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/contents/test.vue'),
  },
  {
    path: '/document/:contentId',
    name: 'document',
    meta: {
      title: '資料',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/contents/doc.vue'),
  },
  {
    path: '/screening',
    name: 'screening',
    meta: {
      title: '審査申請',
      authRequired: true,
    },
    component: () => import('../pages/screening/index.vue'),
  },
  {
    path: '/new-screening',
    name: 'newScreening',
    meta: {
      title: '申請書類登録状況',
      authRequired: true,
      proxyLogin: true,
    },
    component: () => import('../pages/screening/new/index.vue'),
  },
  {
    path: '/update-screening',
    name: 'updateScreening',
    meta: {
      title: '更新申請書類登録状況',
      authRequired: true,
      proxyLogin: true,
    },
    component: () => import('../pages/screening/update/index.vue'),
  },
  {
    path: '/update-cases/:branchNumber(\\d+)',
    name: 'updateCases',
    meta: {
      title: '更新症例登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/update/cases/index.vue'),
  },
  {
    path: '/update-basic-info',
    name: 'updateBasicInfo',
    meta: {
      title: '認定医基本情報登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/update/basic-info/index.vue'),
  },
  {
    path: '/register-update-conference',
    name: 'registerUpdateConference',
    meta: {
      title: '学術集会・セミナー参加登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/update/conferences/register.vue'),
  },
  {
    path: '/upload-update-conference',
    name: 'uploadUpdateConference',
    meta: {
      title: '学術集会・セミナー参加一覧 参加証アップロード',
      authRequired: true,
    },
    component: () => import('../pages/screening/update/conferences/upload.vue'),
  },
  {
    path: '/new-basic-info',
    name: 'newBasicInfo',
    meta: {
      title: '認定医基本情報登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/basic-info/index.vue'),
  },
  {
    path: '/new-cases/:screeningId(\\d+)/:branchNumber(\\d+)',
    name: 'newCases',
    meta: {
      title: '症例登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/cases/index.vue'),
  },
  {
    path: '/new-career',
    name: 'newCareer',
    meta: {
      title: 'がん診療に関する職歴登録',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/career/index.vue'),
  },
  {
    path: '/new-conference-presentation',
    name: 'newConferencePresentation',
    meta: {
      title: 'がん診療についての業績目録（学会発表）入力',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/conference-presentation/index.vue'),
  },
  {
    path: '/new-thesis-presentation',
    name: 'newThesisPresentation',
    meta: {
      title: 'がん診療についての業績目録（論文発表）入力',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/thesis-presentation/index.vue'),
  },
  {
    path: '/new-seminar',
    name: 'newSeminar',
    meta: {
      title: '学術単位目録 入力',
      authRequired: true,
    },
    component: () => import('../pages/screening/new/seminar/index.vue'),
  },
  {
    path: '/notifications',
    name: 'notificationList',
    meta: {
      title: 'インフォメーション一覧',
      authRequired: true,
    },
    component: () => import('../pages/notification/list.vue'),
  },
  {
    path: '/notifications/:id',
    name: 'notificationDetail',
    meta: {
      title: 'インフォメーション詳細',
      authRequired: true,
    },
    component: () => import('../pages/notification/detail.vue'),
  },
  {
    path: '/edit-user',
    name: 'editUserInformation',
    meta: {
      title: '変更届',
      authRequired: true,
    },
    component: () => import('../pages/edit-user/index.vue'),
  },
  {
    path: '/edit-mail',
    name: 'editMailAddress',
    meta: {
      title: 'メールアドレス変更届',
      authRequired: true,
    },
    component: () => import('../pages/edit-mail/index.vue'),
  },
  {
    path: '/cpl-change-email',
    name: 'completeChangeMailAddress',
    meta: {
      title: 'メールアドレス本登録完了',
      authRequired: true,
    },
    component: () => import('../pages/edit-mail/complete.vue'),
  },
  {
    path: '/payment-history',
    name: 'paymentHistory',
    meta: {
      title: '支払履歴',
      authRequired: true,
    },
    component: () => import('../pages/payment-history/index.vue'),
  },
  {
    path: '/inquiry',
    name: 'inquiryAdministrator',
    meta: {
      title: '事務局へのお問合せ',
      authRequired: true,
    },
    component: () => import('../pages/inquiry/index.vue'),
  },
  {
    path: '/certified-user-list',
    name: 'certifiedUserList',
    meta: {
      title: '認定医名簿​',
      authRequired: true,
    },
    component: () => import('../pages/user-list/index.vue'),
  },
  {
    path: '/facility-list',
    name: 'facilityList',
    meta: {
      title: '施設名簿​',
      authRequired: true,
    },
    component: () => import('../pages/facility-list/index.vue'),
  },
  {
    path: '/auth/500',
    name: '500Error',
    meta: {
      title: 'Error 500',
      authRequired: true,
    },
    component: () => import('../views/errors/500.vue'),
  },
  {
    path: '/:catchAll(.*)', // すべてのパスにマッチ
    name: 'NotFound',
    meta: {
      title: 'Error 404',
      authRequired: false,
    },
    component: () => import('../views/errors/404-cover.vue'),
  },
];
